import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  private tokenKey = 'edgeApp';

  set(data: any): void {
    localStorage.setItem(this.tokenKey, JSON.stringify(data));
  }
}
